import lb from '@/lib/loopback';


export function findTipospublicacao(settings = {}) {
  return lb
    .find('/Tipospublicacoes/', settings);
}

export default {
  findTipospublicacao,
};
